import React from "react";
import FlatButton from "material-ui/FlatButton";
import Dialog from "material-ui/Dialog";
import { connect } from "react-redux";

import PcTextField from "../PcTextField";
import addNew from "../../../actions/addNew";

class AddNewcategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = { name: "" };
  }

  componentDidMount() {
    window.setTimeout(
      function() {
        const ref = this.refs["name"];
        if (ref) ref.focusInput();
      }.bind(this),
      200
    );
  }

  handleNameChange = name => this.setState({ name });

  handleAddNewClick = () => {
    const { name } = this.state;
    const { country_id, city_id, chapter_id } = this.props;
    this.props.handleCloseModal();
    this.props.dispatch(
      addNew("category", { name, chapter_id, country_id, city_id })
    );
  };

  render() {
    return (
      <Dialog
        title="Add new category"
        actions={[
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.props.handleCloseModal}
          />,
          <FlatButton
            label="Add"
            primary={true}
            keyboardFocused={true}
            onClick={this.handleAddNewClick}
            disabled={!this.state.name}
          />
        ]}
        modal={false}
        open={true}
        onRequestClose={this.props.handleCloseModal}
      >
        <PcTextField
          handleChange={this.handleNameChange}
          floatingLabelText="name"
          value={this.state.name}
          ref="name"
        />
      </Dialog>
    );
  }
}

const mapStateToProps = ({ data }) => {
  return {
    country_id: data.country.country_id,
    city_id: data.city.city_id,
    chapter_id: data.chapter.chapter_id
  };
};

export default connect(mapStateToProps)(AddNewcategory);
